let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("i3cfl")).then(() => parcelRequire('8kBPZ'));